"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TotalPropertiesLet$ = exports.TotalPropertiesLet$outboundSchema = exports.TotalPropertiesLet$inboundSchema = void 0;
exports.totalPropertiesLetToJSON = totalPropertiesLetToJSON;
exports.totalPropertiesLetFromJSON = totalPropertiesLetFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
/** @internal */
exports.TotalPropertiesLet$inboundSchema = z.object({
    total_properties: z.number().int(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "total_properties": "totalProperties",
    });
});
/** @internal */
exports.TotalPropertiesLet$outboundSchema = z.object({
    totalProperties: z.number().int(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        totalProperties: "total_properties",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var TotalPropertiesLet$;
(function (TotalPropertiesLet$) {
    /** @deprecated use `TotalPropertiesLet$inboundSchema` instead. */
    TotalPropertiesLet$.inboundSchema = exports.TotalPropertiesLet$inboundSchema;
    /** @deprecated use `TotalPropertiesLet$outboundSchema` instead. */
    TotalPropertiesLet$.outboundSchema = exports.TotalPropertiesLet$outboundSchema;
})(TotalPropertiesLet$ || (exports.TotalPropertiesLet$ = TotalPropertiesLet$ = {}));
function totalPropertiesLetToJSON(totalPropertiesLet) {
    return JSON.stringify(exports.TotalPropertiesLet$outboundSchema.parse(totalPropertiesLet));
}
function totalPropertiesLetFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.TotalPropertiesLet$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'TotalPropertiesLet' from JSON`);
}
//# sourceMappingURL=totalpropertieslet.js.map